import { AppRoutes } from "app/common/app-routing-types";

export const platformRoutes: AppRoutes = [
    {
        path: "mailing-list-resubscribe",
        loadComponent: () =>
            import("./mailing-list-resubscribe-page/mailing-list-resubscribe-page.component").then(
                (m) => m.MailingListResubscribePageComponent,
            ),
    },
];
